export const eosio_assert = (str: string) => `eosio_assert: ${str}`
export const eosio_assert_message = (str: string) => `eosio_assert_message: ${str}`
export const eosio_assert_code = (str: bigint) => `eosio_assert_code: ${str}`